import ConfigModel from "../model/ConfigModel";
import configRestRepository from "../repository/ConfigRestRepository";

/**
 * 환경설정 Store
 */
class ConfigStore {
  private _config!: ConfigModel;

  public get config(): ConfigModel {
    return this._config;
  }

  public setConfig(_config: ConfigModel): void {
    this._config = _config;
  }

  /**
   * 환경설정 조회
   */
  public async readConfig(): Promise<void> {
    const result = await configRestRepository.readConfig();

    if (result != null) {
      this.setConfig(new ConfigModel(result));
    }
  }
}

const configStore = new ConfigStore();

export default configStore;
